
    import I18n from 'i18nObj';
    
      import 'translations/cyoe_assignment_sidebar_breakdown_details';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('cyoe_assignment_sidebar_breakdown_details');
  